import * as yup from 'yup'
import { QUESTIONNAIRE_OPEN_ANSWER_MAX_LENGTH, type QuestionnaireItemModel } from '@profilpublic/api-contract/questionnaire'

export const questionnaireFieldName = (item: QuestionnaireItemModel) => `questionnaireAnswer${item.id}`

export default function questionnaireSchema(items: QuestionnaireItemModel[]) {
  const shape: Record<string, yup.AnySchema> = {}

  for (const item of items) {
    const name = questionnaireFieldName(item)

    if (item.kind === 'open') {
      let field = yup
        .string()
        .transform(value => (value === '' ? undefined : value))
        .max(QUESTIONNAIRE_OPEN_ANSWER_MAX_LENGTH, `Réponse de ${QUESTIONNAIRE_OPEN_ANSWER_MAX_LENGTH} caractères maximum`)
      if (item.required) field = field.required('Réponse requise')
      shape[name] = field
    } else if (item.kind === 'closed') {
      let field = yup.string().oneOf(['true', 'false'], 'Réponse requise')
      if (item.required) field = field.required('Réponse requise')
      shape[name] = field
    } else {
      let field = yupFile({ types: ['application/pdf'] })
      if (item.required) field = field.required('Document requis')
      shape[name] = field
    }
  }

  return yup.object(shape)
}
